const jobFieldOptions = [
  { value: "AgriF", label: "Agriculture/Forestry" },
  { value: "Art", label: "Arts/Design" },
  { value: "Finan", label: "Banking/Finance/Investing" },
  { value: "BTradC", label: "Building/Trades/Crafts" },
  { value: "BusiC", label: "Business/Commerce" },
  { value: "Reli", label: "Clergy/Religious Leadership" },
  { value: "Commu", label: "Communications/Media" },
  { value: "Comp", label: "Computers/IT" },
  { value: "Couns", label: "Counseling" },
  { value: "Edu", label: "Education" },
  { value: "Engi", label: "Engineering" },
  { value: "Envi", label: "Environment/Recreation" },
  { value: "Fund", label: "Fundraising" },
  { value: "Health", label: "Health Care" },
  { value: "Homem", label: "Homemaking" },
  { value: "HumRe", label: "Human Resources" },
  { value: "Insur", label: "Insurance" },
  { value: "Lang", label: "Languages" },
  { value: "Legal", label: "Legal Professions" },
  { value: "Libra", label: "Libraries/Archives/Museums" },
  { value: "Mark", label: "Marketing" },
  { value: "Milit", label: "Military/Protective Services" },
  { value: "Other", label: "Other Careers" },
  { value: "PArt", label: "Performing Arts" },
  { value: "Plan", label: "Planning" },
  { value: "PubS", label: "Public Service" },
  { value: "RealE", label: "Real Estate" },
  { value: "Resea", label: "Research & Development" },
  { value: "Sci", label: "Sciences" },
  { value: "SHos", label: "Service/Hospitality" },
  { value: "SoSc", label: "Social Sciences" },
  { value: "SoSer", label: "Social Service" },
  { value: "Sport", label: "Sports" },
  { value: "Stud", label: "Student" },
  { value: "Transp", label: "Transportation/Travel" },
  { value: "Volun", label: "Volunteering" }
];

export default jobFieldOptions;
